import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
export default function Cart() {
  return <section id="cart-content" data-nav="light" className="w-full bg-background text-foreground py-12 md:py-16 lg:py-24 transition-colors">
      <div className="mx-auto max-w-[1360px] px-6 sm:px-10 lg:px-16">
        <WooCommerceCartBlock />
      </div>
    </section>;
}